import React from 'react';
import {TextField, InputAdornment} from '../../../ui-library';
import useEmailFieldVI from '../Controller/EmailFieldVi.controller';
import {ChipAvatar, ChipsBox, EmailChip} from '../Style/EmailFieldVI.style';


const EmailFieldVI = ({ inputLabel, getValue}) => {
    const {emails, validateInput, handleDeleteChip, cleanError, error, inputValue} = useEmailFieldVI({getValue});

    return (
        <TextField
            fullWidth onChange={(e) => cleanError(e)}
            label={inputLabel}
            value={inputValue}
            helperText={error ? error : null}
            inputerror = {error}
            onBlur={validateInput}
            onKeyPress={(e) => e.key === 'Enter' && validateInput()}
            InputProps={{
                startAdornment: emails.length > 0 && (
                    <InputAdornment position='start'>
                        <ChipsBox>
                            {emails.map((email, index) => (
                                <EmailChip
                                    key={index}
                                    label={email}
                                    onDelete={() => handleDeleteChip(email)}
                                    avatar={<ChipAvatar>{email.charAt(0).toUpperCase()}</ChipAvatar>}
                                />
                            ))}
                        </ChipsBox>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default EmailFieldVI;
